import type {ListMaterialsSearch} from "./-types";

import {listMaterialsQueryOptions} from "@project/application/engineering/materials";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {MaterialsPage} from "./-page/materials.page";
import {MaterialsPending} from "./-page/materials.pending";
import {listMaterialsSearchSchema} from "./-types";

export type {ListMaterialsSearch} from "./-types";

export const Route = createFileRoute("/_app/engineering/materials/")({
  component: MaterialsPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") {
      return queryClient.ensureQueryData(listMaterialsQueryOptions(deps as ListMaterialsSearch));
    }

    void queryClient.prefetchQuery(listMaterialsQueryOptions(deps as ListMaterialsSearch));

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: MaterialsPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => listMaterialsSearchSchema.parse(search),
});
